export const TV_CONNECT_IMAGE = 'https://static.talparadio.nl/images/juke/connect-juke-tv-header.jpg';
export const TV_CONNECT_IMAGE_WITH_TEXT = 'https://static.talparadio.nl/images/juke/connect-juke-tv.jpg';

export const SCREENS = {
  info: {
    title: 'JUKE OP JE TV?',
    text:
      'Om de JUKE-app op je tv te gebruiken heb je een gratis profiel nodig. Login of registreer je binnen een minuutje. ' +
      'Daarna kun je naar al je favoriete radiozenders luisteren!',
    image: TV_CONNECT_IMAGE,
    loginLabel: 'Inloggen',
    registerLabel: 'Registreren',
  },
  sync: {
    loadingLabel: 'Laden...',
    buttonLabel: 'Connect',
    errorMessage: 'Er is iets mis gegaan! Probeer het nog een keer.',
  },
  success: {
    title: 'GELUKT!',
    image: TV_CONNECT_IMAGE,
    buttonLabel: 'JUKE ze!',
  },
};
